export { TranslationsService } from './service-setup/TranslationsService';

import { diContainer, serviceNames } from './service-setup/diContainer';
diContainer.get(serviceNames.translationsService).register();
